export default {"src":"/_next/static/media/icon-delivery-vehicle.fff6ed4c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};